export default {
    'CLICK-BTN-CUSTOMRECHECK-REPRINTLABEL-NEW': {
      key: 'click-btn-customRecheck-reprintLabel-new',
      label: '点击-复核打包一体化(新)-拣货容器页-补打标签'
    },
    'CLICK-BTN-CUSTOMRECHECKGOODS-REPRINTLABEL-NEW': {
      key: 'click-btn-customRecheckGoods-reprintLabel-new',
      label: '点击-复核打包一体化(新)-商品页-补打标签'
    },
    
    'SCAN-INPUT-CUSTOMRECHECK-SCANPICKINGCONTAINER-NEW': {
      key: 'scan-input-customRecheck-scanPickingContainer-new',
      label: '扫描-复核打包一体化(新)-扫描拣货容器-触发扫描'
    },
    'SCAN-INPUT-CUSTOMRECHECK-SCANGOODSBARCODE-NEW': {
      key: 'scan-input-customRecheck-scanGoodsBarcode-new',
      label: '扫描-复核打包一体化(新)-扫描商品条码-触发扫描'
    },
    'CLICK-BTN-CUSTOMRECHECK-FULLPACKAGE-NEW': {
      key: 'click-btn-customRecheck-fullPackage-new',
      label: '点击-复核打包一体化(新)-满包裹-触发点击'
    },
    'CLICK-BTN-CUSTOMRECHECK-CONFIRMINPUTPACKAGECOUNT-NEW': {
      key: 'click-btn-customRecheck-confirmInputPackageCount-new',
      label: '点击-复核打包一体化(新)-输入包裹数量确认-触发'
    },
    'SCAN-INPUT-CUSTOMRECHECK-SCANCONSUMABLESCONFIRM-NEW': {
      key: 'scan-input-customRecheck-scanConsumablesConfirm-new',
      label: '扫描-复核打包一体化(新)-扫描耗材确认-触发'
    },
    'CLICK-BTN-CUSTOMRECHECK-DIFFERCONFIRM-NEW': {
      key: 'click-btn-customRecheck-differConfirm-new',
      label: '点击-复核打包一体化(新)-差异确认-触发'
    },
    'CLICK-BTN-CUSTOMRECHECK-CLOSECONTAINER-NEW': {
      key: 'click-btn-customRecheck-closeContainer-new',
      label: '点击-复核打包一体化(新)-关闭容器-触发'
    }
  }